/**
 * @file 文档页
 * @author Wanzhongyun
 */
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';
import DocTopMenu from './components/doc-menu/components/doc-top-menu/DocTopMenu';
import useDocument from './documentHooks';
import Header from '../../components/header/HeaderWithStore';
import Footer from '../footer/footer';
import VersionSelect from './components/version-select';
import DocContent from './DocContens';
import { IDocumentParams } from './type';
import './style.scss';

const Document: React.FC<IDocumentParams> = props => {
    const { isPage, Components } = props;
    const { docMenuHooks, versionSelectHook } = useDocument(props);

    return (
        <div className="paddle-lite-inference">
            <div className="page paddle-doc-page">
                <Header />
                <ReactStickyPolyfill>
                    <div className="paddle-doc-page-docs-top">
                        <div className="paddle-doc-page-docs-top-menu">
                            {versionSelectHook.options.length > 0 && <VersionSelect {...versionSelectHook} />}
                        </div>
                        <div className="paddle-doc-page-docs-top-inner">
                            {!isPage && <DocTopMenu {...docMenuHooks.top} onClick={docMenuHooks.onTopMenuChange} />}
                        </div>
                    </div>
                </ReactStickyPolyfill>
                {isPage ? (
                    <Components
                        menuList={docMenuHooks.left.menuList}
                        pageProps={props}
                        currentValue={versionSelectHook.value}
                    />
                ) : (
                    <DocContent
                        currentList={docMenuHooks.left.menuList}
                        pageProps={props}
                        currentValue={versionSelectHook.value}
                    />
                )}
                <Footer />
            </div>
        </div>
    );
};

export default Document;
